module.exports = __webpack_public_path__ + "img/7.1.b91d2bb9.png";